import culture from "./culture-codes";

export const formatDate = (date: unknown, cultureCode: string): string => {
  if (!(date instanceof Date)) {
    return "";
  }

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  switch (cultureCode) {
    case culture.finnish:
      return `${day}.${month}.${year}`;
    case culture.swedishFinland:
      return `${day}.${month}.${year}`;
    case culture.swedish:
      return date.toLocaleDateString(culture.swedish, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    case culture.danish:
      return `${day}.${month}.${year}`;
    case culture.norwegian:
      return date.toLocaleDateString(culture.norwegian, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    case culture.english:
      return `${day}/${month}/${year}`;
    default:
      return date.toLocaleDateString(cultureCode);
  }
};

export const formatDateAndTime = (
  date: unknown,
  cultureCode: string,
): string => {
  if (!(date instanceof Date)) {
    return "";
  }

  const formattedDate = formatDate(date, cultureCode);
  const hours = date.getHours();
  const hoursFormatted = hours.toString().padStart(2, "0");
  const minutesFormatted = date.getMinutes().toString().padStart(2, "0");
  const formattedTime = `${hours}:${minutesFormatted}`;
  const formattedToLocalTime = date.toLocaleTimeString(cultureCode);

  switch (cultureCode) {
    case culture.finnish:
      return `${formattedDate} klo ${formattedTime}`;
    case culture.swedishFinland:
      return `${formattedDate} ${formattedTime}`;
    case culture.swedish:
      return `${formattedDate} ${hoursFormatted}:${minutesFormatted}`;
    case culture.danish:
      return `${formattedDate} ${formattedTime}`;
    case culture.norwegian:
      return `${formattedDate} ${formattedToLocalTime}`;
    case culture.english:
      return `${formattedDate} ${formattedTime}`;
    default:
      return formattedToLocalTime;
  }
};
